/**
 * Shared GTM tracking helper.
 * Adds common page, device, session, and customer fields to every event.
 */
(function (window, document) {
  'use strict';

  var SESSION_STORAGE_KEY = 'ga_sessionId';
  var COOKIE_SESSION_KEY = 'ga_cookieSessionId';
  var SESSION_MAX_AGE = 30 * 60;

  function isPlainObject(value) {
    return Object.prototype.toString.call(value) === '[object Object]';
  }

  function merge(target, source) {
    target = target || {};
    if (!source) return target;

    Object.keys(source).forEach(function (key) {
      target[key] = source[key];
    });

    return target;
  }

  function compact(value) {
    if (Array.isArray(value)) {
      return value.map(compact).filter(function (item) {
        return item !== undefined && item !== null;
      });
    }

    if (!isPlainObject(value)) return value;

    Object.keys(value).forEach(function (key) {
      if (value[key] === undefined || value[key] === null) {
        delete value[key];
        return;
      }

      value[key] = compact(value[key]);
    });

    return value;
  }

  function getCookie(name) {
    var match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
    return match ? decodeURIComponent(match[2]) : '';
  }

  function setCookie(name, value, maxAge) {
    var cookie = name + '=' + encodeURIComponent(value) + '; path=/; max-age=' + maxAge + '; SameSite=Lax';
    if (window.location.protocol === 'https:') cookie += '; Secure';
    document.cookie = cookie;
  }

  function storageGet(key) {
    try {
      return window.sessionStorage.getItem(key);
    } catch (error) {
      return '';
    }
  }

  function storageSet(key, value) {
    try {
      window.sessionStorage.setItem(key, value);
    } catch (error) {
      // sessionStorage can be unavailable in privacy modes.
    }
  }

  function generateUUID() {
    if (window.crypto && window.crypto.getRandomValues) {
      return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (char) {
        var random = window.crypto.getRandomValues(new Uint8Array(1))[0] % 16;
        var value = char === 'x' ? random : (random & 0x3) | 0x8;
        return value.toString(16);
      });
    }

    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (char) {
      var random = Math.random() * 16 | 0;
      var value = char === 'x' ? random : (random & 0x3) | 0x8;
      return value.toString(16);
    });
  }

  function getSessionId() {
    var sessionId = storageGet(SESSION_STORAGE_KEY) || getCookie(COOKIE_SESSION_KEY);
    if (!sessionId) sessionId = generateUUID();

    storageSet(SESSION_STORAGE_KEY, sessionId);
    setCookie(COOKIE_SESSION_KEY, sessionId, SESSION_MAX_AGE);
    return sessionId;
  }

  function getUserId() {
    if (!window.gaGlobalVars || window.gaGlobalVars.userId === undefined || window.gaGlobalVars.userId === null) {
      return '';
    }

    return String(window.gaGlobalVars.userId);
  }

  function getCurrency() {
    if (window.gaGlobalVars?.currency) return window.gaGlobalVars.currency;
    if (window.Shopify?.currency?.active) return window.Shopify.currency.active;
    return '';
  }

  function getDeviceType() {
    var ua = window.navigator.userAgent || '';
    var platform = window.navigator.platform || '';
    var maxTouchPoints = window.navigator.maxTouchPoints || 0;

    if (/iPad|Tablet/i.test(ua) || (platform === 'MacIntel' && maxTouchPoints > 1)) {
      return 'Tablet';
    }

    if (/Mobi|Android|iPhone|iPod/i.test(ua)) return 'M';
    if (window.matchMedia?.('(max-width: 767px)').matches) return 'M';
    return 'PC';
  }

  function commonPayload() {
    return {
      page_location: window.location.href,
      page_referrer: document.referrer || '',
      device_type: getDeviceType(),
      session_id: getSessionId(),
      user_id: getUserId(),
      market_code: window.location.hostname === 'uk.googoohair.com' ? 'UK' : 'US'
    };
  }

  function normalizePayload(payload) {
    if (!payload) return payload;

    if (payload.page_type === undefined && payload.event_category !== undefined) {
      payload.page_type = payload.event_category;
    }

    return payload;
  }

  function track(params) {
    if (!params?.event) return null;
    window.dataLayer = window.dataLayer || [];
    var common = commonPayload();
    var payload = compact(normalizePayload(merge(common, params)));

    // GTM processes this callback before the following event, including when
    // both are queued before the container loads. Keep the dataLayer intact.
    window.dataLayer.push(function () {
      this.reset(); 
    });

   // console.log("=====执行这里=====");
   // console.log(payload);
    
    
    window.dataLayer.push(payload);
    return payload;
  }

  var api = window.brandTracking || {};
  api.track = track;
  api.getCommonPayload = commonPayload;
  api.getSessionId = getSessionId;
  api.getCurrency = getCurrency;

  window.brandTracking = api;
  window.brandTrack = track;
})(window, document);
